import React from "react";
import { Container, Breadcrumb } from "react-bootstrap";
import { Link, useParams, Navigate } from "react-router-dom";
import styled from "styled-components";
import ContactSupport from "../components/ContactSupport";
import { FaHome } from "react-icons/fa";
import { articles } from "../data/helpArticles";
import { getRelativeTimeString } from "../utils/dateUtils";

const StyledContainer = styled(Container)`
  max-width: 800px;
  padding: 2rem 1rem;
`;

const ArticleHeader = styled.div`
  margin-bottom: 2rem;
`;

const LastUpdated = styled.div`
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
`;

const ArticleContent = styled.div`
  margin-bottom: 3rem;
`;

const StyledBreadcrumb = styled(Breadcrumb)`
  margin-bottom: 2rem;

  .breadcrumb {
    margin-bottom: 0;
  }

  a {
    color: var(--primary-bg);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const HelpArticle: React.FC = () => {
  const { category, article: articleSlug } = useParams<{
    category: string;
    article: string;
  }>();

  if (
    !category ||
    !articleSlug ||
    !articles[category] ||
    !articles[category][articleSlug]
  ) {
    return <Navigate to="/help" replace />;
  }

  const article = articles[category][articleSlug];

  return (
    <StyledContainer>
      <StyledBreadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
          <FaHome />
        </Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/help" }}>
          Help Center
        </Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/help/${category}` }}>
          {category.charAt(0).toUpperCase() + category.slice(1)}
        </Breadcrumb.Item>
      </StyledBreadcrumb>

      <ArticleHeader>
        <h1>{article.title}</h1>
        <LastUpdated>
          Last updated {getRelativeTimeString(article.lastUpdated)}
        </LastUpdated>
      </ArticleHeader>

      <ArticleContent>
        {article.content.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </ArticleContent>

      <ContactSupport />
    </StyledContainer>
  );
};

export default HelpArticle;
